module.exports = __webpack_public_path__ + "static/media/manual_edit_bold.70cfca72.jpg";